import React from 'react'
import {
  ContainerDimensionsContextProvider,
  Loading,
  Modal,
} from '@therms/atalaya'

const ViewLocation = React.lazy(
  () => import('@src/modules/Locations/router/screens/ViewLocation'),
)

interface ViewLocationModalProps {
  closeHandler: () => void
  locationId: string
}

function ViewLocationModal({
  closeHandler,
  locationId,
}: ViewLocationModalProps) {
  return (
    <Modal closeHandler={closeHandler} escPressClose width="xl">
      <ContainerDimensionsContextProvider>
        <React.Suspense fallback={<Loading overlay />}>
          <ViewLocation locationId={locationId} />
        </React.Suspense>
      </ContainerDimensionsContextProvider>
    </Modal>
  )
}

export { ViewLocationModal }
